import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "./pages/userContext";
import { RecoilRoot } from "recoil";
import { Provider } from "react-redux"; // Ajoutez ceci
import store from "./store/store"; // Assurez-vous que le chemin est correct

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* Ajoutez le Provider ici */}
    <RecoilRoot>
      <React.StrictMode>
        <UserProvider>
          <App />
        </UserProvider>
      </React.StrictMode>
    </RecoilRoot>
  </Provider>
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js") // Assurez-vous que ce fichier se trouve dans le dossier public
    .then((registration) => {
      console.log("Service Worker enregistré avec succès:", registration);
    })
    .catch((error) => {
      console.error(
        "Erreur lors de l'enregistrement du Service Worker:",
        error
      );
    });
}
